import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  IListUsersResponse,
  IProfile,
  IUserByPk,
  IUserToSaveReq,
} from '../../interface';
import { CustomHttpInterface } from '../../interface';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly baseUrl = `${environment.API_DOMAINS.URL_USER}/users-api`;

  constructor(private http: HttpClient) {}

  listUsers(
    params: HttpParams,
  ): Observable<CustomHttpInterface<IListUsersResponse>> {
    const headers = { 'Content-Type': 'application/json' };
    return this.http.get<CustomHttpInterface<IListUsersResponse>>(
      `${this.baseUrl}/getUser`,
      {
        params,
        headers,
      },
    );
  }

  getById(uId: number): Observable<CustomHttpInterface<IUserByPk | null>> {
    const headers = { 'Content-Type': 'application/json' };
    return this.http.get<CustomHttpInterface<IUserByPk | null>>(
      `${this.baseUrl}/getUser?uId=${uId}`,
      {
        headers,
      },
    );
  }

  getByEmail(
    email: string,
  ): Observable<CustomHttpInterface<IUserByPk | null> | any> {
    const headers = { 'Content-Type': 'application/json' };
    return this.http.get<CustomHttpInterface<IUserByPk | null>>(
      `${this.baseUrl}/getUser?uEmail=${email}`,
      {
        headers,
      },
    );
  }

  createUpdateUser(data: IUserToSaveReq): Observable<CustomHttpInterface<any>> {
    const body = JSON.stringify(data);
    const headers = { 'Content-Type': 'application/json' };
    return this.http.post<CustomHttpInterface<any>>(
      `${this.baseUrl}/createUpdateUser`,
      body,
      { headers },
    );
  }

  deleteUser(usId: number): Observable<CustomHttpInterface<any>> {
    const headers = { 'Content-Type': 'application/json' };
    return this.http.post<CustomHttpInterface<any>>(
      `${this.baseUrl}/deleteLogicUser`,
      { usId },
      { headers },
    );
  }

  getRuts(): Observable<CustomHttpInterface<{ usRut: string }[]>> {
    const headers = { 'Content-Type': 'application/json' };
    return this.http.get<CustomHttpInterface<{ usRut: string }[]>>(
      `${this.baseUrl}/getRuts`,
      {
        headers,
      },
    );
  }
listProfile(): Observable<CustomHttpInterface<IProfile[] | null>> {
  const headers = { 'Content-Type': 'application/json' };
  return this.http.get<CustomHttpInterface<IProfile[] | null>>(
    `${this.baseUrl}/profile/listProfile`,
    { headers }
  );
}

}
